import { MonitoringFeedAdd } from '#app/routes/mocra+/_form+/components/monitoring-feeds/add.tsx'
import { MonitoringFeedCard } from '#app/routes/mocra+/_form+/components/monitoring-feeds/card.tsx'
import { type MonitoringFeedDraft } from '#app/routes/mocra+/_form+/components/monitoring-feeds/types.ts'
import { Section } from '#app/routes/mocra+/_form+/components/section.tsx'
import { type SectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'

type MonitoringFeedListItem = {
	readonly draft: MonitoringFeedDraft
	readonly errors: readonly string[]
}

type Props = {
	readonly resources: SectionResources
	readonly feeds: ReadonlyArray<MonitoringFeedListItem>
	readonly onAdd: (draft: MonitoringFeedDraft) => void
	readonly onEdit: (index: number) => void
	readonly onRemove: (index: number) => void
}

export function MonitoringFeedsSection({
	resources,
	feeds,
	onAdd,
	onEdit,
	onRemove,
}: Props) {
	return (
		<Section
			title="Monitoring feeds"
			description="List the regulatory feeds, alerts, and newsletters you monitor plus how often they’re reviewed."
			mocraSections={resources.mocraSections}
			templates={resources.templates}
		>
			<div className="space-y-3">
				{feeds.length > 0 ? (
					feeds.map((feed, index) => {
						const errors = feed.errors
						return (
							<MonitoringFeedCard
								key={`monitoring-feed-${index}`}
								feed={feed.draft}
								onEdit={() => onEdit(index)}
								onRemove={() => onRemove(index)}
								errors={errors.length > 0 ? [...errors] : undefined}
							/>
						)
					})
				) : (
					<p className="text-muted-foreground text-sm">
						Add the newsletters, alerts, or dashboards you watch so we can tie
						owners to the right updates.
					</p>
				)}
			</div>
			<MonitoringFeedAdd onSubmit={onAdd} />
		</Section>
	)
}
